import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import StockTransferServices from "../../../services/StockTransfer";
import Form from "./components/form";

const CreateStockTransfer = () => {

  const route = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const createStockTransfer = async (payload) => {
    setLoading(true)
    try {
      await StockTransferServices.createStockTransfer(payload)
      SuccessToaster('Create Successfully')
      navigate(route?.stockTransfers)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Stock Transfer</h4>
              <h6>Create new stock transfer</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={createStockTransfer} loading={loading} />
      </div>
    </div>
  );
};

export default CreateStockTransfer;
